import React from 'react'
import { observer } from 'mobx-react'
import {
  CloseModalOnPipe,
  Form,
  OpenModalOnPipe,
  Operation,
  useOperation,
  useValue
} from '@morningtrain/react-resources'
import Modal from 'widgets/modals/Modal'
import PropTypes from 'prop-types'
import { DecodedTranslation, Translation } from '@morningtrain/react-translations'
import * as Auth from '@morningtrain/react-auth'
import { CallbackOnPipe, Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-pipelines'
import * as UI from 'ui'

function DeleteModelPipeline (props) {
  let {
    resourceName = null,
    modelKey = 'name',
    children
  } = props

  const modalRef = React.useRef()

  const _resolve = React.useRef()
  const _reject = React.useRef()

  const handleOnSubmit = (data) => {
    if (_resolve.current !== null) {
      _resolve.current(data)
    }
  }

  const handleClose = (err) => {
    if (_reject.current !== null) {
      _reject.current(err)
    }
  }

  const handleOnPipe = (payload) => {
    return new Promise((resolve, reject) => {
      _resolve.current = data => {
        payload.data = data
        resolve(data)
      }
      _reject.current = (err) => {
        reject(err)
      }
    })
  }

  const operation = useOperation()

  if (resourceName === null && operation) {
    resourceName = operation.resource.slug
  }

  const nameValue = useValue(modelKey)

  return (
    <Auth.CanUseModel permission={`api.${resourceName}.delete`}>
      <Modal ref={modalRef} handleClose={handleClose}>
        <Operation namespace='api' resourceName={resourceName} operationName='delete'>
          <Form onSubmit={handleOnSubmit} submitTo='delete' preventParentOperationRefresh>
            <UI.Text>
              {
                nameValue
                  ? (
                    <DecodedTranslation name='generic.are_you_sure_delete' data={{ entry: 'model:' + modelKey }} />
                    )
                  : (
                    <Translation name='generic.are_you_sure' />
                    )
              }
            </UI.Text>
            <UI.ButtonWrap className='my-4 mx-1' leftAlign>
              <Pipeline>
                <TriggerPipelineOnClick>
                  <UI.Button>
                    <Translation name='generic.cancel' />
                  </UI.Button>
                </TriggerPipelineOnClick>
                <CloseModalOnPipe modalRef={modalRef} />
              </Pipeline>
              <UI.SubmitButton color='red'>
                <Translation name='generic.actions.delete' />
              </UI.SubmitButton>
            </UI.ButtonWrap>
          </Form>
        </Operation>
      </Modal>
      <Pipeline>
        <OpenModalOnPipe modalRef={modalRef} />
        <CallbackOnPipe callback={handleOnPipe} />
        <CloseModalOnPipe modalRef={modalRef} />
        {children}
        {props.pipes}
      </Pipeline>
    </Auth.CanUseModel>
  )
}

DeleteModelPipeline.propTypes = {
  resourceName: PropTypes.string,
  modelKey: PropTypes.string,
  resetSmartview: PropTypes.bool,
  pipes: PropTypes.node
}

export default observer(DeleteModelPipeline)
